/* HolzWurmDesign Startseiten-Animationen: Hero-Sequenz, Scroll-Choreografie,
   Laser-Schritte, gravierte Tafel-Rahmen, Parallax, Zurueck-nach-oben. */
(function () {
  'use strict';
  var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;

  function ready(fn) {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn);
    else fn();
  }

  ready(function () {
    /* ---------- Zurueck nach oben (immer aktiv) ---------- */
    var top = document.createElement('button');
    top.className = 'hwd-top';
    top.type = 'button';
    top.setAttribute('aria-label', 'Zurück nach oben');
    top.innerHTML = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 19V6M5.5 12.5 12 6l6.5 6.5"/></svg>';
    top.addEventListener('click', function () {
      window.scrollTo({ top: 0, behavior: reduce ? 'auto' : 'smooth' });
    });
    document.body.appendChild(top);
    var ticking = false;
    function onScroll() {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () {
        top.classList.toggle('hwd-on', window.scrollY > 700);
        ticking = false;
      });
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();

    if (reduce) return;

    /* ---------- Hero-Sequenz ---------- */
    var hero = document.querySelector('.banner');
    if (hero) {
      var h = hero.querySelector('.banner__heading');
      if (h && h.textContent.trim()) {
        var txt = h.textContent.trim();
        h.setAttribute('aria-label', txt);
        h.innerHTML = txt
          .split(/\s+/)
          .map(function (w, i) {
            return '<span class="hwd-w" aria-hidden="true" style="--wi:' + i + '">' + w + '</span>';
          })
          .join(' ');
        h.insertAdjacentHTML(
          'afterend',
          '<svg class="hwd-heroline" viewBox="0 0 170 20" aria-hidden="true"><path d="M2,12 C40,4 84,18 122,8 S162,7 167,10"/></svg>'
        );
      }
      hero.classList.add('hwd-hero-ready');
      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          hero.classList.add('hwd-hero-go');
        });
      });
    }

    /* ---------- Scroll-Choreografie ---------- */
    var fx = [];
    function tag(el, cls, delay) {
      if (!el || el.classList.contains('hwd-fx')) return;
      el.classList.add('hwd-fx');
      if (cls) el.classList.add(cls);
      if (delay) el.style.setProperty('--fxd', delay);
      fx.push(el);
    }

    document.querySelectorAll('.image-with-text').forEach(function (s) {
      var media = s.querySelector('.image-with-text__media-item') || s.querySelector('.image-with-text__media');
      var content = s.querySelector('.image-with-text__content');
      tag(media, 'hwd-fx--left');
      tag(content, null, '0.18s');
    });
    document.querySelectorAll('.rich-text__wrapper, .newsletter__wrapper, .collapsible-content__wrapper').forEach(function (el) {
      tag(el);
    });

    /* Titel-Unterstriche (kein Verstecken, nur Linie) */
    document.querySelectorAll('.title-wrapper .title, .collapsible-content__heading, .rich-text__heading, .product__title > h1, .hwd-cfg__title').forEach(function (t) {
      if (t.closest('.banner')) return;
      t.classList.add('hwd-t');
      if (getComputedStyle(t).textAlign !== 'center') t.classList.add('hwd-t--left');
      fx.push(t);
    });

    /* Produktseiten: Einstiegssequenz wie am Hero */
    var pInfoW = document.querySelector('.product__info-wrapper');
    if (pInfoW) {
      var pMediaW = document.querySelector('.product__media-wrapper');
      if (pMediaW) tag(pMediaW, 'hwd-fx--left');
      [].slice.call(pInfoW.children).slice(0, 10).forEach(function (el, i) {
        tag(el, null, (0.1 + i * 0.07).toFixed(2) + 's');
      });
      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          if (pMediaW) pMediaW.classList.add('hwd-go');
          [].slice.call(pInfoW.children).forEach(function (el) { el.classList.add('hwd-go'); });
        });
      });
    }

    /* Laser-Schritte */
    var steps = document.querySelector('.hwd-steps');
    if (steps) fx.push(steps);

    /* Gravierte Tafel-Rahmen fuer Farbbloecke */
    function laserFrame(el) {
      if (!el || el.querySelector('.hwd-lframe')) return;
      if (getComputedStyle(el).position === 'static') el.style.position = 'relative';
      var ns = 'http://www.w3.org/2000/svg';
      var svg = document.createElementNS(ns, 'svg');
      svg.setAttribute('class', 'hwd-lframe');
      svg.setAttribute('aria-hidden', 'true');
      var r = document.createElementNS(ns, 'rect');
      r.setAttribute('pathLength', '100');
      svg.appendChild(r);
      el.appendChild(svg);
      el.classList.add('hwd-lhost');
    }
    document.querySelectorAll('.image-with-text__content, .newsletter__wrapper, .rich-text__blocks').forEach(laserFrame);

    /* Sanfte Bild-Parallax in Bild+Text-Sektionen (nur Desktop) */
    var plxEls = [].slice.call(document.querySelectorAll('.image-with-text__media img'));
    if (plxEls.length && matchMedia('(min-width: 750px)').matches) {
      var plxTick = false;
      var plx = function () {
        if (plxTick) return;
        plxTick = true;
        requestAnimationFrame(function () {
          var vh = window.innerHeight;
          plxEls.forEach(function (img) {
            var r = img.getBoundingClientRect();
            if (r.bottom < 0 || r.top > vh) return;
            var p = (r.top + r.height / 2 - vh / 2) / vh;
            img.style.transform = 'translateY(' + (p * -16).toFixed(1) + 'px) scale(1.06)';
          });
          plxTick = false;
        });
      };
      window.addEventListener('scroll', plx, { passive: true });
      plx();
    }

    if (!('IntersectionObserver' in window)) {
      fx.forEach(function (el) { el.classList.add('hwd-go'); });
      return;
    }
    var obs = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (en) {
          if (en.isIntersecting) {
            en.target.classList.add('hwd-go');
            obs.unobserve(en.target);
          }
        });
      },
      { rootMargin: '0px 0px -10% 0px', threshold: 0.12 }
    );
    fx.forEach(function (el) { obs.observe(el); });

    /* ---------- Sicherheitsnetz ----------
       Die Bloecke starten auf opacity:0 und werden erst durch .hwd-go sichtbar.
       Wenn der IntersectionObserver aus irgendeinem Grund nicht ausloest
       (gedrosselte Hintergrund-Tabs, Layoutverschiebung beim Bild-Laden,
       abgebrochene Transition), blieben Inhalte unsichtbar und der
       Laser-Rahmen halb gezeichnet. Diese Nachkontrollen stellen sicher,
       dass jeder Block spaetestens nach kurzer Zeit vollstaendig da ist. */
    function sweep(force) {
      var vh = window.innerHeight || document.documentElement.clientHeight || 0;
      fx.forEach(function (el) {
        if (el.classList.contains('hwd-go')) return;
        var r = el.getBoundingClientRect();
        var imViewport = r.top < vh && r.bottom > 0;
        if (force || imViewport) {
          el.classList.add('hwd-go');
          obs.unobserve(el);
        }
      });
    }
    window.addEventListener('load', function () { setTimeout(sweep, 400); });
    window.addEventListener('scroll', function () { sweep(false); }, { passive: true });
    setTimeout(function () { sweep(false); }, 2500);
    /* Letzte Instanz: nach 8 Sekunden ist kein Block mehr unsichtbar. */
    setTimeout(function () { sweep(true); }, 8000);
  });
})();
